import { Typography } from '@material-ui/core';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { Alert } from '@superdispatch/ui-lab';
import { ReactNode } from 'react';
import { ReasonDTO } from 'shared/modules/carrier-profile/data/VerifiedCarrierApplicationStatusDTO';
import styled from 'styled-components';

interface MessagesListProps {
  listStyle: 'plain' | 'standard';
}

const MessagesList = styled.ul<MessagesListProps>`
  margin: 0;
  color: ${ColorDynamic.Dark500};
  padding-left: ${({ listStyle }) => (listStyle === 'standard' ? '20px' : '0')};
  list-style: ${({ listStyle }) =>
    listStyle === 'standard' ? 'inherit' : 'none'};
`;

const ExtendedMessage = styled.div`
  padding-bottom: 4px;
`;

interface FieldAdditionalMessagesProps {
  messages?: ReasonDTO[];
  extendedMessages?: Record<string, ReactNode>;
  title?: string;
  additionalMessage?: ReactNode;
  externalNotes?: string;
  actions?: ReactNode;
  variant: 'error' | 'warning';
  listStyle?: MessagesListProps['listStyle'];
}

export function VerificationStatusMessages({
  messages,
  extendedMessages = {},
  title,
  additionalMessage,
  externalNotes,
  actions,
  variant,
  listStyle = 'standard',
}: FieldAdditionalMessagesProps) {
  return (
    <Alert severity={variant === 'error' ? 'critical' : 'caution'}>
      <Stack aria-label="Verification application error message" space="small">
        <Stack space="small">
          {title && <Typography>{title}</Typography>}
          {messages && (
            <MessagesList listStyle={listStyle}>
              {messages.map((error) => (
                <li key={error.type}>
                  <Stack space="xxsmall">
                    <Typography color="textPrimary">
                      {error.description}
                    </Typography>
                    {extendedMessages[error.type] && (
                      <ExtendedMessage>
                        {extendedMessages[error.type]}
                      </ExtendedMessage>
                    )}
                  </Stack>
                </li>
              ))}
            </MessagesList>
          )}
          {typeof additionalMessage === 'string' ? (
            <Typography color="textPrimary">{additionalMessage}</Typography>
          ) : additionalMessage ? (
            additionalMessage
          ) : null}
          {!!externalNotes && (
            <Stack space="small">
              <Typography color="inherit">Notes:</Typography>
              <Typography color="textPrimary">
                <i>{externalNotes}</i>
              </Typography>
            </Stack>
          )}
        </Stack>
        {actions}
      </Stack>
    </Alert>
  );
}
